import { render, staticRenderFns } from "./addClassMien.vue?vue&type=template&id=34570a2b&"
import script from "./addClassMien.vue?vue&type=script&lang=js&"
export * from "./addClassMien.vue?vue&type=script&lang=js&"
import style0 from "./addClassMien.vue?vue&type=style&index=0&id=34570a2b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports